





























































import Vue from 'vue'

export default Vue.extend({
  name: 'CodesReservedList',
  props: {
    pool: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      headers: [
        { text: 'Code', value: 'value', sortable: false },
        { text: 'Comment', value: 'Comment', sortable: false }
      ]
    }
  }
})
